export default "__VITE_ASSET__BDJqMvXz__"